import authClient from './authClient';

export const userLogin = (userLoginData) => {
    return authClient.post(process.env.REACT_APP_API_URL + '/userLogin', userLoginData);
};